import { Image, Link } from '@akinon/next/components';
import { SwiperReact, SwiperSlide } from '@theme/components';
import { cn } from '@theme/utils';

export const SpecialPageTabs = ({ data }) => {
  return (
    <>
      <div className="sm:container pl-4 my-5 md:mt-4 md:mb-10">
        <SwiperReact slidesPerView="auto" spaceBetween={16}>
          {data?.attributes?.tabs?.map((tab, index) => (
            <SwiperSlide key={index} className="min-w-[100px] max-w-max">
              <Link
                href={tab.value.tab_link}
                className={cn(
                  'flex items-center justify-center h-12 px-3 border rounded-sm border-black',
                  tab?.kwargs?.value?.tab_icon?.url && 'pl-2'
                )}
              >
                {tab?.kwargs?.value?.tab_icon?.url && (
                  <Image
                    src={tab.kwargs.value.tab_icon.url}
                    alt={tab.value.tab_text}
                    width={24}
                    height={24}
                    className="mr-2"
                  />
                )}
                <div className="font-bold leading-normal text-center">
                  {tab.value.tab_text}
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </SwiperReact>
      </div>
    </>
  );
};
